export enum MatchRenderNameValueEnum {
  isTaxSimple = "is_tax_simple",
  fz = "fz",
  bgTypeId = "bg_type_id",
}

export const isMatchRenderNameValueEnum = (
  value: string
): value is MatchRenderNameValueEnum => {
  return (
    value === MatchRenderNameValueEnum.isTaxSimple ||
    value === MatchRenderNameValueEnum.fz ||
    value === MatchRenderNameValueEnum.bgTypeId
  );
};
